import URIS from 'constants/uris';
import http from 'services/http';

getMe.operation = 'READ';
getMe.idFrom = () => 'getMeId';
export function getMe() {
  return http.get(`${URIS.ME}?include[]=permissions`);
}
